export const appendFields = ({
  fields,
  append,
  value,
}: {
  fields: number;
  append: (value: { width: string; height: string }) => void;
  value: { width: string; height: string };
}) => {
  if (fields) {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < fields; i++) {
      append(value);
    }
  }
};
